import { z } from 'zod';

/** How long a new key lasts, in days. */
export const API_KEY_DAYS = [90, 180, 365, 730] as const;

export const createApiKeyBody = z.object({
  organisationId: z.string().uuid(),
  name: z.string().trim().min(1, 'Say what the key is for').max(64, 'At most 64 characters'),
  days: z.coerce
    .number()
    .refine((n) => (API_KEY_DAYS as readonly number[]).includes(n), 'Choose how long it lasts')
    .default(365),
});
export type CreateApiKeyBody = z.input<typeof createApiKeyBody>;

/** A key as listed: never the key itself. */
export interface ApiKey {
  id: string;
  organisationId: string;
  organisationName: string;
  name: string;
  prefix: string;
  createdAt: string;
  createdByName: string | null;
  expiresAt: string;
  revokedAt: string | null;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
  requestCount: number;
}

/** Just made: the only time the whole key is shown. */
export interface NewApiKey extends ApiKey {
  key: string;
}
